import { PackageKey } from "../constants/options";

export const GetMiniUrl = (path: string) => {
  return `/mini${path}`;
};

export const IsMiniPackage = (pkg: any) => {
  // return pkg.key === PackageKey.KEY_MINI_PKG;
  return pkg.key === PackageKey.KEY_CLINIC || pkg.key === PackageKey.KEY_MINI_PKG;
};